import React, { FC } from "react";
import { Button, ErrorMessage, Input } from "@shared/components";
import { ReactComponent as PlusIcon } from "@assets/files/icons/general/plus.svg";
import { ReactComponent as DeleteIcon } from "@assets/files/icons/general/clear.svg";
import { FieldArray, useFormikContext } from "formik";

import { ClientFormShape } from "./formHelpers";
import "./AdditionalEmailsField.scss";

export interface AdditionalEmailsFieldProps {
  disabled?: boolean;
  onChangeForm: () => void;
}

export const AdditionalEmailsField: FC<AdditionalEmailsFieldProps> = ({ disabled, onChangeForm }) => {
  const context = useFormikContext<ClientFormShape>();
  const emails = context.values.additional_emails || [];

  return (
    <div className="input-wrapper">
      {emails.length > 0 && <label className="label">Secondary Email(s)</label>}
      <div className="emails">
        <FieldArray
          name="additional_emails"
          render={({ remove, insert, push }) => (
            <div>
              {emails.length > 0 && (
                <div className="rows">
                  {emails.map((email, index) => (
                    <div key={index} className="input-wrapper">
                      <div className="row">
                        <Input
                          disabled={disabled}
                          onKeyDown={onChangeForm}
                          value={email}
                          name={`additional_emails.${index}`}
                        />
                        {!disabled && (
                          <>
                            <Button
                              type="button"
                              buttonStyle="link"
                              onClick={() => {
                                remove(index);
                                insert(index, context.values.email);
                                context.setFieldValue("email", email, false);
                                onChangeForm();
                              }}
                            >
                              Make Primary
                            </Button>
                            <Button
                              type="button"
                              buttonStyle="clear"
                              onClick={() => {
                                remove(index);
                                onChangeForm();
                              }}
                            >
                              <DeleteIcon />
                            </Button>
                          </>
                        )}
                      </div>
                      <ErrorMessage
                        isTouched={context.touched.additional_emails}
                        error={context.errors.additional_emails?.[index]}
                      />
                    </div>
                  ))}
                </div>
              )}

              {!disabled && (
                <Button
                  buttonStyle="link"
                  type="button"
                  onClick={() => {
                    push("");
                    onChangeForm();
                  }}
                >
                  <PlusIcon /> Add Email
                </Button>
              )}
            </div>
          )}
        />
      </div>
    </div>
  );
};
